import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import * as React from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';
import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as leadActions from "../../actions/leadActions";
// ----------------------------------------------------------------------
const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));
// ----------------------------------------------------------------------
const CamBankingPage = (props) => {
  const { leadId, id } = useParams();
  const location = useLocation();
  const {leadInfo, actions, usersData, fetchLeadIdBankStatement,bankDetails } = props;
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate(); 
  const [file, setFile] = useState('');
  const [activeLoanTab, setActiveLoanTab] = useState(0);
  const [tabBankInfo, setTabBankInfo] = useState([]);
 

  const handleTabClick = (index,bankInfo) => {
    setActiveLoanTab(index); // Update active tab index
    setTabBankInfo(bankInfo);
  };
  
    
  useEffect(() => {
    if (bankDetails && bankDetails.length > 0) {
      const bankInfo = bankDetails[0];
      setTabBankInfo(bankInfo);
    }
  }, [bankDetails]);


  return (
    <>
      <div id="main-wrap" className='mt-4 cam_section'>
        <div className='row justify-content-between'>
          <div className="row">
            <div className='col-md-12'>
            
             {(bankDetails) && (
                <>
                    <div className='row'>
                        <div className="col-md-12 mt-1">
                            <div className="tabs">
                                {bankDetails.map((tab, index) => (
                                    <button
                                        key={index}
                                        className={activeLoanTab === index ? 'btn active activTab btn-primary' : 'btn'}
                                        onClick={() => handleTabClick(index,tab)}
                                        type="button"
                                    >
                                        Bank - {tab?.bank_overview_details?.accounts?.[0]?.bank}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <hr />          
                        <div className="col-md-12 mt-4">
                        <div className='row'> 
                        {tabBankInfo && (
                            <>
                                <div className="col-md-6">
                                <h5 className='nav nav-pills mb-4'>Summary</h5>
                                <div className='row  '>  
                                  
                                
                                   <div className="col-md-6 mb-2"><b> Name of the Account Holder :</b></div>
                                   <div className="col-md-6 mb-2">{ tabBankInfo?.bank_overview_details?.accounts?.[0]?.bank }</div>
                                  
                                   <div className="col-md-6 mb-2"><b>Account Category :</b></div>
                                   <div className="col-md-6 mb-2"> { tabBankInfo?.bank_overview_details?.accounts?.[0]?.account_category }</div>

                                   <div className="col-md-6 mb-2"><b>Name of the Bank :</b></div>
                                   <div className="col-md-6 mb-2"> { tabBankInfo?.bank_overview_details?.accounts?.[0]?.bank }</div>


                                   <div className="col-md-6 mb-2"><b>Account Number :</b></div>
                                   <div className="col-md-6 mb-2"> { tabBankInfo?.bank_overview_details?.accounts?.[0]?.account_number }</div>


                                   <div className="col-md-6 mb-2"><b>OD Limit :</b></div>
                                   <div className="col-md-6 mb-2"> { tabBankInfo?.bank_overview_details?.accounts?.[0]?.od_limit }</div>
                                    
                                   </div>
                                </div>

                                <div className="col-md-6"> 
                                   <h5 className='nav nav-pills mb-4'>Monthwise Details   &nbsp;  &nbsp;<span className='float-right text-danger mt-1'> { Object.keys(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.cnt_credit || [])[0] ?? '' }</span></h5>
                                  
                                   <div className='row  '>
                                   <div className="col-md-6 mb-2" title="cnt_credit"><b>Total No. of Credit Transactions :</b></div>
                                   <div className="col-md-6 mb-2"> 
                                   {
                                    parseFloat(Object.values(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.cnt_credit || [])[0] ?? 0).toFixed(2)
                                   }
                                   </div>

                                   <div className="col-md-6 mb-2" title="amt_credit"> <b>Total Amount of Credit Transactions :</b></div>
                                   <div className="col-md-6 mb-2">  
                                   {
                                    parseFloat(Object.values(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.amt_credit || [])[0] ?? 0).toFixed(2)
                                   }
                                   </div>

                                   <div className="col-md-6 mb-2" title="cnt_debit"> <b>Total No. of Debit Transactions :</b></div>
                                   <div className="col-md-6 mb-2">   
                                   {
                                    parseFloat(Object.values(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.cnt_debit || [])[0] ?? 0).toFixed(2)
                                   }
                                   </div>

                                   <div className="col-md-6 mb-2" title="amt_debit"> <b>Total Amount of Debit Transactions :</b></div>
                                   <div className="col-md-6 mb-2"> 
                                   {
                                    parseFloat(Object.values(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.amt_debit || [])[0] ?? 0).toFixed(2)
                                   }
                                   </div>

                                   <div className="col-md-6 mb-2" title="cnt_inward_cheque_bounce_credit"> <b>Total No. of Inward Cheque Bounces :</b></div>
                                   <div className="col-md-6 mb-2">  
                                   {
                                    parseFloat(Object.values(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.cnt_inward_cheque_bounce_credit || [])[0] ?? 0).toFixed(2)
                                   }

                                   </div>

                                    
                                   <div className="col-md-6 mb-2" title="cnt_outward_cheque_bounce_debit"> <b>Total No. of Outward Cheque Bounces : </b></div>
                                   <div className="col-md-6 mb-2"> 
                                     
                                    {
                                    parseFloat(Object.values(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.cnt_outward_cheque_bounce_debit || [])[0] ?? 0).toFixed(2)
                                   }
                                    </div>

                                   <div className="col-md-6 mb-2" title="avg_bal"> <b>Average EOD Balance : </b></div>
                                   <div className="col-md-6 mb-2">  
                                   {
                                    parseFloat(Object.values(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.avg_bal || [])[0] ?? 0).toFixed(2)
                                   }
                                   </div>

                                   <div className="col-md-6 mb-2" title="net_cash_inflow"> <b>Net Cashflow : </b></div>
                                   <div className="col-md-6 mb-2"> 
                                   {
                                    parseFloat(Object.values(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.net_cash_inflow || [])[0] ?? 0).toFixed(2)
                                   }
                                   </div>

                                   <div className="col-md-6 mb-2" title="cnt_loan_credits"> <b>Number of Loan Credits  : </b></div>
                                   <div className="col-md-6 mb-2"> 
                                   {
                                    parseFloat(Object.values(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.cnt_loan_credits || [])[0] ?? 0).toFixed(2)
                                   }

                                   </div>

                                   <div className="col-md-6 mb-2" title="cnt_auto_debit_payment_bounce_credit"> <b>Number of Auto-Debit Bounces : </b></div>
                                   <div className="col-md-6 mb-2"> 
                                   {
                                    parseFloat(Object.values(tabBankInfo?.bank_overview_monthwise_details?.monthly_analysis?.cnt_auto_debit_payment_bounce_credit || [])[0] ?? 0).toFixed(2)
                                   }
                                   </div>


                                   </div>
                                </div>
                            </>
                         )}
                        </div>
                        </div>
                    </div>
                  
                </>
            )}
            </div>
          </div>
             
        </div>
      </div>
    </>
  );
}


function mapStateToProps(state) {
  return {
    usersData: state.usersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default, leadBankStatementActions.default, leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CamBankingPage);
